import { createElementVNode as _createElementVNode, renderSlot as _renderSlot, withModifiers as _withModifiers, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Teleport as _Teleport, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "acModal"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createBlock(_Teleport, { to: "#modals" }, [
    (_ctx.modelValue)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createElementVNode("div", {
            class: "acModal_overlay",
            onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.onBackdropClose && _ctx.onBackdropClose(...args)))
          }),
          _createElementVNode("div", {
            class: _normalizeClass(['acModal_content', `-${_ctx.modalType}`, `-mobile-${_ctx.mobileModalType}`]),
            onClick: _cache[1] || (_cache[1] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.onBackdropClose && _ctx.onBackdropClose(...args)), ["self"]))
          }, [
            _renderSlot(_ctx.$slots, "default")
          ], 2)
        ]))
      : _createCommentVNode("", true)
  ]))
}